import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Smokeleaf from '../entities/smokeleaf'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface SmokeleafState extends ListState<Smokeleaf>{
    editSmokeleaf:Smokeleaf,
    analyseSmokeleaf:Smokeleaf,
}
class UserMutations extends ListMutations<Smokeleaf>{

}
class SmokeleafModule extends ListModule<SmokeleafState,any,Smokeleaf>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Smokeleaf>(),
        filterlist:new Array<Smokeleaf>(),
        loading:false,
        editSmokeleaf:new Smokeleaf(),
        analyseSmokeleaf:new Smokeleaf()
    }
    actions={
        async getAll(context:ActionContext<SmokeleafState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThSmokeleaf/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Smokeleaf>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getAlllist(context:ActionContext<SmokeleafState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThSmokeleaf/GetAllList',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Smokeleaf>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPaged(context:ActionContext<SmokeleafState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/ThSmokeleaf/GetPaged',{params:payload.data});
            
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Smokeleaf>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getfilter(context:ActionContext<SmokeleafState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ThSmokeleaf/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Smokeleaf>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async create(context:ActionContext<SmokeleafState,any>,payload:any){
            await Ajax.post('/api/services/app/ThSmokeleaf/Create',payload.data);
        },
        async uploadimg(context:ActionContext<SmokeleafState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<SmokeleafState,any>,payload:any){
            await Ajax.put('/api/services/app/ThSmokeleaf/Update',payload.data);
        },
        async delete(context:ActionContext<SmokeleafState,any>,payload:any){
            await Ajax.delete('/api/services/app/ThSmokeleaf/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<SmokeleafState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/ThSmokeleaf/GetById?Id='+payload.id);
            return reponse.data.result as Smokeleaf;
        }
    };
    mutations={
        setCurrentPage(state:SmokeleafState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:SmokeleafState,pagesize:number){
            state.pageSize=pagesize;
        },
        analyse(state: SmokeleafState, smokeleaf: Smokeleaf) {
            state.analyseSmokeleaf = smokeleaf;
        },
        edit(state:SmokeleafState,smokeleaf:Smokeleaf){
            
            state.editSmokeleaf=smokeleaf;
            //console.log(state.editFloor);
        }
    }
}
const smokeleafModule=new SmokeleafModule();
export default smokeleafModule;